export const UploadButtonWidgetId = 'UploadButtonWidget';

export enum UploadButtonWidgetAttributes {
  LABEL_GROUP = 'groupLabel',
  MULTIPLE = 'multiple',
  ACCEPT = 'accept',
  HELPER_TEXT = 'helperText',
}
